// import httpService from '@/service/http-service';
// import BASE_API from '@/api/dataBase';
import XEUtils from 'xe-utils/methods/xe-utils';
import GlobalVar from '@/common/js/global';
import store from '../store';
import { fmoney } from '@/common/js/util';

/**
 * 日期格式化函数，注意这时候传过来的是国际标准的时间格式
 * 格式化只保留yyyy-MM-dd hh:mm:ss,第二个参数传true的话返回yyyy-MM-dd
 */
export function dateTimeFormat(time, flag) {
  if (undefined == time) return;
  var date = new Date(time);
  var year = date.getFullYear();
  /* 在日期格式中，月份是从0开始的，因此要加0
   * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
   * */
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  // 拼接
  if (!flag) {
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
  } else {
    return year + '-' + month + '-' + day;
  }
}

/**
 * 日期格式化函数，注意这时候传过来的是国际标准的时间格式
 * 格式化只保留yyyy-MM-dd
 */
export function dateFormat(time) {
  if (undefined == time) return;
  var date = new Date(time);
  var year = date.getFullYear();
  /* 在日期格式中，月份是从0开始的，因此要加0
   * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
   * */
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  // 拼接
  return year + '-' + month + '-' + day;
}

/**
 * 日期格式化函数，注意这时候传过来的是yyyy-MM-dd hh:mm:ss的格式的日期
 * 格式化只保留yyyy-MM-dd
 * 2019-04-23 18:00:00  => 2019-04-23
 * @param {String} value
 */
export function dateSubstr(value) {
  var newDate = value;
  if (null != value) {
    newDate = newDate.substr(0, 10);
  }
  return newDate;
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

/**
 * @desc 保留两位小数
 * @author 李文旭
 * @date 2020年4月14日16:17:42
 * @param {String} num 需要格式化的数据
 * @returns {String} 格式化数据
 */
export function moneyParser(num) {
  let value = Number(num);
  if (Number.isFinite(value)) {
    value = value.toFixed(2);
    return Number(value);
  } else {
    return '';
  }
}

export function getDictNameByCode(code, type) {
  // TODO 性能差感觉没必要拷贝一份
  // let dictListMap = XEUtils.clone(store.state.dict.dictListMap, true);
  let dictListMap = store.state.dict.dictListMap;
  if (dictListMap[type]) {
    let dictRecord = dictListMap[type];
    let tempValue = dictRecord.find((it) => it.value == code);
    if (tempValue != null) {
      return tempValue.label;
    } else {
      return code;
    }
  } else {
    return code;
  }
}

export function formatTableColumn(value, type, extraData) {
  if (type == 'formatAmount') {
    return fmoney(XEUtils.toNumber(value).toFixed(GlobalVar.aPoint), 2);
  } else if (type == 'formatBankcard') {
    return XEUtils.commafy(value, { spaceNumber: 4, separator: ' ' });
  } else if (type == 'formatAmountRound') {
    return value == '' && !XEUtils.isNumber(value)
      ? ''
      : fmoney(XEUtils.toNumber(value).toFixed(GlobalVar.aPoint), 2);
  } else if (type == 'formatQuality') {
    return fmoney(XEUtils.toNumber(value).toFixed(GlobalVar.qPoint), 3);
  } else if (type == 'formatPrice') {
    return fmoney(XEUtils.toNumber(value).toFixed(GlobalVar.pPoint), 3);
  } else if (type == 'inputFormatAmountRound') {
    if (!extraData['focusFlag']) {
      //失去焦点  显示2位不显示千分符
      if (value === '' || value === null) {
        return '';
      }
      value = fmoney(XEUtils.toNumber(value).toFixed(extraData.precision), extraData.precision);
      return value;
    } else {
      //触发焦点 显示6位千分符
      // return fmoney(XEUtils.toNumber(value).toFixed(2), 2)
    }
  }
  return value;
}

// 如果是物贸的时候
export const formateQuantityToWumao = (value, isWumao) => {
  if (isWumao) {
    return XEUtils.toNumber(value).toFixed(8);
  } else {
    return fmoney(XEUtils.toNumber(value).toFixed(GlobalVar.qPoint), 3);
  }
};
